/* eslint-disable import/prefer-default-export */
export const GET_RESCHEDULED_REQUEST = 'GET_RESCHEDULED_REQUEST';
